module.exports = __webpack_public_path__ + "static/media/AETUpload_Template.9f69bf86.xlsx";